import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function ArtistsDetailHeader() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-white shadow-sm' : 'bg-white'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex items-center justify-between h-20">
          <Link to="/" className="flex items-center gap-3 cursor-pointer">
            <div className="w-10 h-10 flex items-center justify-center bg-gray-900 text-white rounded-lg">
              <i className="ri-music-2-line text-xl"></i>
            </div>
            <div>
              <div className="text-sm font-bold text-gray-900 leading-tight">日本音楽会場協会</div>
              <div className="text-xs text-gray-500">東京支部</div>
            </div>
          </Link>

          <nav className="flex items-center gap-8">
            <Link to="/#about" className="text-sm text-gray-600 hover:text-gray-900 transition-colors cursor-pointer whitespace-nowrap">
              支部について
            </Link>
            <Link to="/#venues" className="text-sm text-gray-600 hover:text-gray-900 transition-colors cursor-pointer whitespace-nowrap">
              参加会場
            </Link>
            <Link to="/#artists" className="text-sm text-gray-600 hover:text-gray-900 transition-colors cursor-pointer whitespace-nowrap">
              登録アーティスト
            </Link>
            <Link to="/#schedule" className="text-sm text-gray-600 hover:text-gray-900 transition-colors cursor-pointer whitespace-nowrap">
              ライブスケジュール
            </Link>
            <Link to="/#contact" className="text-sm text-gray-600 hover:text-gray-900 transition-colors cursor-pointer whitespace-nowrap">
              お問い合わせ
            </Link>
          </nav>
        </div>
      </div>
    </header>
  );
}
